import * as React from 'react';

function SvgComponent(props, ref) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <style>{'.prefix__st0{fill:#0072ff}'}</style>

      <g id="prefix__Layer_2">
        <circle className="prefix__st0" cx={52.1} cy={32.4} r={7.9} />

        <circle className="prefix__st0" cx={31.1} cy={36.3} r={7.9} />

        <circle className="prefix__st0" cx={11} cy={40.2} r={7} />

        <path
          className="prefix__st0"
          d="M11 49c-3 0-5.5 1.9-6.5 4.5-.5 1.2.4 2.5 1.7 2.5h9.6c1.3 0 2.2-1.3 1.8-2.5C16.5 50.9 14 49 11 49zM25.2 56h11.9c1.1 0 1.9-.9 1.9-1.9v-.3c0-4.7-4.1-8.4-8.9-7.8-4 .5-6.8 4.1-6.8 8.1-.1 1 .8 1.9 1.9 1.9zM51.1 42.1c-4 .5-6.8 4.1-6.8 8.1v3c0 1.6 1.3 2.9 2.9 2.9h10c1.6 0 2.9-1.3 2.9-2.9v-3.3c-.1-4.7-4.2-8.5-9-7.8z"
        />
      </g>
    </svg>
  );
}

const SocialMediaIcon = React.forwardRef(SvgComponent);

export default SocialMediaIcon;
